import { render, staticRenderFns } from "./ConsultationsPostForm.vue?vue&type=template&id=ef55ea10&scoped=true&"
import script from "./ConsultationsPostForm.vue?vue&type=script&lang=ts&"
export * from "./ConsultationsPostForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConsultationsPostForm.vue?vue&type=style&index=0&id=ef55ea10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef55ea10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
